"use strict";

exports.__esModule = true;
exports.ElementPathRenderer = ElementPathRenderer;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Renders each element in a path to a specific element,
 * based on a configuration object and a dictionary of components.
 */
function ElementPathRenderer(_ref) {
  var path = _ref.path,
    _ref$reverse = _ref.reverse,
    reverse = _ref$reverse === void 0 ? false : _ref$reverse,
    _ref$skipRoot = _ref.skipRoot,
    skipRoot = _ref$skipRoot === void 0 ? false : _ref$skipRoot,
    components = _ref.components,
    config = _ref.config,
    _ref$modifyProps = _ref.modifyProps,
    modifyProps = _ref$modifyProps === void 0 ? function (input) {
      return input;
    } : _ref$modifyProps,
    Wrapper = _ref.Wrapper;
  var subject = config;
  var toRender = [];
  var currentPath = [];
  var maybeRender = function maybeRender(element) {
    if (Array.isArray(element) || typeof element.type !== "string") {
      return;
    }
    var Component = components[element.type];
    if (!Component) {
      return;
    }
    var key = currentPath.join("/");
    var body = /*#__PURE__*/_react["default"].createElement(Component, modifyProps(Object.assign({
      type: subject.type
    }, subject.props, {
      key: key,
      path: currentPath
    })));
    if (Wrapper) {
      toRender.push(/*#__PURE__*/_react["default"].createElement(Wrapper, {
        key: key,
        path: currentPath,
        element: subject
      }, body));
    } else {
      toRender.push(body);
    }
  };
  if (!skipRoot) {
    maybeRender(subject);
  }
  for (var i = 0; i < path.length; i++) {
    var prop = path[i];
    subject = subject[prop];
    if (!subject) {
      break;
    }
    currentPath = currentPath.concat(prop);
    maybeRender(subject);
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, reverse ? toRender.reverse() : toRender);
}